import { render, staticRenderFns } from "./NewCossaVersion.vue?vue&type=template&id=a84c0b2a"
import script from "./NewCossaVersion.vue?vue&type=script&lang=js"
export * from "./NewCossaVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports